export enum ContactsPermissions {
  VIEW_CONTACTS = "view_contacts",
  UPDATE_CONTACTS = "update_contacts",
  DELETE_CONTACTS = "delete_contacts",
}

export const ContactsPermissionsText: Record<ContactsPermissions, string> = {
  [ContactsPermissions.VIEW_CONTACTS]: "View Contacts",
  [ContactsPermissions.UPDATE_CONTACTS]: "Update Contacts",
  [ContactsPermissions.DELETE_CONTACTS]: "Delete Contacts",
};
